'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');
var isBeforeDay = require('./isBeforeDay.cjs');

function parseDateWithoutYearString(dateWithoutYearString) {
  const [monthString, dayString] = dateWithoutYearString.substring(2).split("-");
  return {
    monthString,
    dayString
  };
}
function assembleDateWithoutYearStringWithYear({
  dateWithoutYearString,
  year
}) {
  const { monthString, dayString } = parseDateWithoutYearString(
    dateWithoutYearString
  );
  return parsers.isoDatePartToDate(`${year}-${monthString}-${dayString}`);
}
function parseDateWithoutYearStringRange({
  range,
  year
}) {
  const [fromDate, rawToDate] = range.map((dateWithoutYearString) => {
    return assembleDateWithoutYearStringWithYear({
      dateWithoutYearString,
      year
    });
  });
  const toDate = dateFns.isBefore(rawToDate, fromDate) ? dateFns.addYears(rawToDate, 1) : rawToDate;
  return [fromDate, toDate];
}
function isPast({
  dateWithoutYearString,
  year,
  now
}) {
  return isBeforeDay.isBeforeDay(
    assembleDateWithoutYearStringWithYear({ year, dateWithoutYearString }),
    now
  );
}

exports.isPast = isPast;
exports.parseDateWithoutYearString = parseDateWithoutYearString;
exports.parseDateWithoutYearStringRange = parseDateWithoutYearStringRange;
//# sourceMappingURL=dateWithoutYear.cjs.map
